import { render, staticRenderFns } from "./uploadBox.vue?vue&type=template&id=3e40d823&scoped=true&"
import script from "./uploadBox.vue?vue&type=script&lang=js&"
export * from "./uploadBox.vue?vue&type=script&lang=js&"
import style0 from "./uploadBox.vue?vue&type=style&index=0&id=3e40d823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40d823",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
